import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Icon, makeStyles } from '@material-ui/core';

import { useCurrentUser } from '@klp/auth';
import { useAppParams } from '@klp/core/app/useAppParams';
import { ActionLink } from '@klp/design/ActionButton';
import { Block } from '@klp/design/Block';
import { Loader } from '@klp/design/Loader';
import { FileDownload } from '@klp/filedownload/index';
import { Main } from '@klp/layout';

import { messageApiRoutes } from '../api';
import { MessageCard } from '../components';
import { MessageCardActions } from '../components/MessageCardActions';
import { MessageBoardRoutes } from '../config';
import { useGetMessageQuery } from '../rtkApi';

const useStyles = makeStyles(() => ({
    messageHeaderBox: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}));

export const MessageSingle: React.FC = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { messageId, selectedClient } = useAppParams();
    const { isAdmin } = useCurrentUser();

    const { data, isLoading: loading } = useGetMessageQuery({
        isAdmin,
        id: messageId ? parseInt(messageId, 10) : undefined,
        selectedKunde: selectedClient?.kundeNummer,
    });

    const message = data?.message;

    if (!message) {
        return null;
    }

    return (
        <Main>
            <Block marginBottom="compact" className={classes.messageHeaderBox}>
                <Block>
                    <ActionLink
                        actionType="linkBack"
                        translation="message.backButton"
                        href={MessageBoardRoutes.moduleRoute()}
                    />
                </Block>
                {!isAdmin && (
                    <Button variant="outlined" startIcon={<Icon>print</Icon>}>
                        <FileDownload
                            path={messageApiRoutes.messagePreview(message.id)}
                            name={`${message.title}.pdf`}
                        >
                            <>{t('message.download')}</>
                        </FileDownload>
                    </Button>
                )}
            </Block>
            <Loader isLoading={loading}>
                <Grid container={true}>
                    <Grid item={true} xs={12}>
                        {isAdmin && <MessageCardActions message={message} />}
                    </Grid>
                    <Grid item={true} sm={10} md={8}>
                        <MessageCard
                            message={message}
                            isAdmin={isAdmin ?? false}
                        />
                    </Grid>
                </Grid>
            </Loader>
        </Main>
    );
};
